import { DepartmentModel } from './department.model'
import { ProductModel } from './product.model'

/** Secteur géographique rattaché à un user (forme allégée renvoyée par l'API). */
export interface UserSectorModel {
  id: number
  name: string
  color: string | null
}

export type WorkDayKey =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'

export interface WorkHoursDay {
  start: string
  end: string
  enabled: boolean
  /**
   * Nuit à l'hôtel le soir de ce jour : le technicien ne rentre pas chez lui.
   * Conséquence : le trajet dernière intervention → domicile le soir de ce jour et
   * le trajet domicile → 1ère intervention le lendemain matin ne sont pas
   * calculés (cf. logique de trajet côté backend).
   */
  hotel: boolean
}

export type WorkHours = Record<WorkDayKey, WorkHoursDay>

export const DEFAULT_WORK_HOURS: WorkHours = {
  monday: { start: '08:00', end: '18:00', enabled: true, hotel: false },
  tuesday: { start: '08:00', end: '18:00', enabled: true, hotel: false },
  wednesday: { start: '08:00', end: '18:00', enabled: true, hotel: false },
  thursday: { start: '08:00', end: '18:00', enabled: true, hotel: false },
  friday: { start: '08:00', end: '17:00', enabled: true, hotel: false },
  saturday: { start: '08:00', end: '12:00', enabled: false, hotel: false },
  sunday: { start: '08:00', end: '12:00', enabled: false, hotel: false },
}

export interface UserModel {
  id: number
  initials: string
  lastname: string
  firstname: string
  fullName: string
  email: string
  idAbm: number | null
  idNrj: number | null
  idBb: number | null
  departments: DepartmentModel[]
  products: ProductModel[]
  /** Secteurs géographiques rattachés (peut être absent selon l'endpoint). */
  sectors?: UserSectorModel[]
  color: string
  erpSource: string
  postalCode: string
  locality: string
  homeLatitude: number
  homeLongitude: number
  workHours: WorkHours
}
